import { ReactElement, useMemo } from 'react';

import { TCookieConsentTexts } from '@skillarea/lib-frontend';
import { Trans, useTranslation } from 'react-i18next';

export const useCookieConsentTexts = (
  policyElement: ReactElement,
): TCookieConsentTexts => {
  const { i18n, t } = useTranslation('common');

  return useMemo(
    () => ({
      title: t('cookies.title'),
      text: (
        <Trans i18nKey="cookies.text" ns="common">
          {policyElement}
        </Trans>
      ),
      accept: t('cookies.accept'),
      acceptMobile: t('cookies.acceptMobile'),
    }),
    [i18n.language, policyElement, t],
  );
};
